import decode from "jwt-decode";
import axios from "axios";
export default class AuthService {
  constructor(domain) {
    this.domain = API_URL;
    this.httpRequest = this.httpRequest.bind(this);
    this.login = this.login.bind(this);
    this.getProfile = this.getProfile.bind(this);
    this.getCompanyDetails= this.getCompanyDetails.bind(this);
  }

  login(username, password) {
    return this.httpRequest("post", "auth/login", {
      email: username,
      password: password
    })
      .then(this._checkStatus)
      .then(res => {
        this.setToken(res.data.token);
        return Promise.resolve(res.data);
      });
  }

  register(username, password, code, newsletter) {
    return this.httpRequest("post", "auth/register", {
      username: username,
      email: username,
      password: password,
      code: code,
      newsletter: newsletter
    })
      .then(this._checkStatus)
      .then(res => {
        return Promise.resolve(res.data);
      });
  }

  loggedIn() {
    const token = this.getToken();
    return !!token && !this.isTokenExpired(token);
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token);
      return decoded.exp < Date.now() / 1000;
    } catch (err) {
      return false;
    }
  }

  setToken(idToken) {
    localStorage.setItem("id_token", idToken);
  }

  getToken() {
    try {
      return localStorage.getItem("id_token");
    } catch (err) {
      return false;
    }
  }

  logout() {
    localStorage.removeItem("id_token");
  }

  getProfile() {
    try {
      let profile = decode(this.getToken());

      profile.scope = profile.scope.map(function(obj) {
        return obj.role;
      });


      /*
        this.getCompanyDetails(profile.sub).then(datas => {
          profile.companyDetails = datas;
        });

      */

      //console.log("profile complet depuis  Auth ",profile);

      return profile;
    } catch (err) {
      return;
    }
  }


  // récuperation des détails de la companie de l'user logué
  getCompanyDetails(email) {
    return this.httpRequest("get", "api/user/selectCompanyInfosByEmail?email=" + email)
        .then(this._checkStatus)
        .then(res => {
        //    console.log('datas de retour de la company de l user ', res.data[0]);
        //    return res.data[0];
            return Promise.resolve(res.data[0]);
        });
  }

  isAdmin() {
    try {
      return this.getProfile().scope.includes("admin");
    } catch (err) {
      return false;
    }
  }

  httpRequest(method, url, body = null) {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json"
    };
    if (this.loggedIn()) {
      headers["Authorization"] = "Bearer " + this.getToken();
    }
    return axios(this.domain + url, {
      method: method,
      headers: headers,
      data: body
    });
  }

  _checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }

  arrayContainsArray(superset, subset) {
    if (0 === subset.length) {
      return false;
    }
    return subset.every(function(value) {
      return superset.indexOf(value) >= 0;
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/AuthService.js